/*
 * @Author: tangke
 * @Date: 2019-01-31 17:00:46
 * @Last Modified by: others
 * @Last Modified time: 2019-04-02 18:53:40
 * training页面下bookClass弹窗
 */
<template>
  <v-layout row>
    <v-dialog v-model="bookClass.dialog"
              max-width="600px">
      <v-btn slot="activator"
             dark
             class="text-none mr-0 mb-3 red-button"
             v-show="TLState==0"
             style="height:28px">Book Class</v-btn>
      <v-card>
        <v-card-title class="title blue-title pa-3 pt-4 ml-2">
          Book Class
          <div class="header-close" title="close" @click="bookClass.dialog = false">
            <v-icon>close</v-icon>
          </div>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form ref="form">
          <v-container grid-list-md px-2>
            <v-layout wrap>
              <v-flex xs12>
                <v-flex xs12>
                    <v-subheader class="pa-0 form-title">Class Type</v-subheader>
                </v-flex>
                <v-select :items="classTypes"
                          v-model="classType"
                          outline
                          single-line
                          @input="changeType"
                          :rules="[rules.required]"
                          required
                          >
                </v-select>
              </v-flex>
              <v-flex xs12 v-if="classType==1 || classType==100">
                <v-flex xs12>
                    <v-subheader class="pa-0 form-title">Class Video Link &nbsp;({{classType==1? '*Contact your DS and fill in the video link of VIP class':'*Contact your DS and fill in the video link of trial class'}})</v-subheader>
                </v-flex>
                <v-text-field 
                          class="class-video-link"
                          v-model="videoLink"
                          outline
                          single-line
                          :rules="[rules.required,rules.video]"
                          required
                          >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <!-- 此处放置日历控件Date of Material Trainer -->
                <v-flex xs12>
                    <v-subheader class="pa-0 form-title">Date</v-subheader>
                </v-flex>
                <v-select :items="checkDates"
                          v-model="checkDate"
                          outline
                          single-line
                          :rules="[rules.required]"
                          required
                          >
                </v-select>
              </v-flex>
            </v-layout>
          </v-container>
          </v-form>

        </v-card-text>
        <v-card-actions class="py-4">
          <v-layout justify-center>
            <v-btn class="text-none red-button dialog-submit"
                   :loading="submitting"
                   :disabled="disabled"
                   @click="submit">Submit</v-btn>
            <v-btn class="white--text text-none cancel-button"
                   @click="bookClass.dialog = false">Cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="goStudyDialog"
              max-width="400"
              content-class="custom-dialog refresh-dialog">
      <v-card>
        <v-toolbar color="white"
                   dense
                   flat>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark flat @click="goStudyDialog=false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>

        </v-toolbar>
        <div>
          <p class="custom-icon"><i class="material-icons warn-icon">error</i></p>
          <v-card-text class='align-center blue-title'>{{ message }}</v-card-text>
          <div class="custom-footer">
            <v-btn class="text-none red-button dialog-submit"
                   @click="$router.push({ path: `/trainingCenter/courseDetail/${courseId}` })"
                   round>Go Study</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { getMaterialTrainerInfo, trainBookClassByType,userExtInfo } from '@/api/teachinfo'
import { formatDate } from '@/utils/date'
export default {
  name: 'bookClass',
  props: {
    bookClass: {
      dialog: false,
    }
  },
  data: () => ({
    classType: -1,
    classTypes: [      
      { text: 'New Tutor Training(NTT)', value: 0 },
      { text: 'English for Kids(EFK1)', value: 4 },
      { text: 'English for Kids(EFK2)', value: 5 },
      { text: 'Accent Training(AT)', value: 2 },      
      { text: 'Grammar Material Training(GMT)', value: 77 },
      //{ text: 'Refresher Course(RC)', value: 1 },
      { text: 'VIP Refresher Course(VIP-RC)', value: 1 },
      { text: 'English for Kids(EFK3)', value: 6 },
      { text: 'Exam Preparation(EP)', value: 11 },
      { text: 'Top Tutor Training(TTT)', value: 3 },
      { text: 'Top Tutor Refreshing Course(TTRC)', value: 100 },
      { text: 'Workshop for VIP tutors(WVIP)', value: 101 },
      { text: 'Workshop for trial tutors(WTT)', value: 102 },
      { text: 'English for Adults(EFA)', value: 103 },
      { text: 'Trial Class for Adults(TCA)', value: 104 },

      // { text: 'Standard Material Training', value: 88 }
      // { text: 'English for Kids', value: 10 },
    ],
    checkDate: '',
    checkDates: [],
    videoLink:'',
    rules: {
      required: value => (!(value === '' || value === -1)) || 'Required.',
      video: value => (value.endsWith(".mp4")) || '*Invaild link format, it must be a MP4 format.'
    },
    submitting:false,
    goStudyDialog:false,
    message:'',
    courseId:null,
    disabled: false,
    TLState: ""
  }),
  methods: {
    changeType () {
      getMaterialTrainerInfo(this.classType).then(res => {
        if (res.data.ErrorCode === 0) {
          this.checkDates = res.data.Body.map(t => {
            return {
              text: formatDate(t.StartTime, 'yyyy-MM-dd hh:mm') + ' - ' + formatDate(t.EndTime, 'yyyy-MM-dd hh:mm') + "(UTC+8)",
              value: { startTime: t.StartTime, endTime: t.EndTime }
            }
          })
        } else {
          this.checkDates = []
          this.checkDate = ''
        }
      })
    },
    submit () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.disabled = true
      this.submitting = true
      trainBookClassByType(this.classType, this.checkDate.startTime, this.checkDate.endTime, this.videoLink).then(res => {
        let type = res.data.ErrorCode === 0 ? 'success' : 'error'
        if(res.data.ErrorCode === 0 && res.data.Body){
          this.goStudyDialog = true;
          this.message = res.data.Msg;
          this.courseId = res.data.Body
        }else{
          this.$root.$alertTips(res.data.Msg, type).then(() => {
            if (res.data.ErrorCode === 0) {
              this.bookClass.dialog = false
              this.$emit('refreshTraining')
            }
          })
        }
        
      }).finally(() => {
          this.submitting = false
          this.disabled = false
      })
    }
  },
  watch: {
    'bookClass.dialog': function (value, oldValue) {
      if (!value) {
        if (this.$refs['form'] !== undefined) {
          this.$refs['form'].resetValidation()
          this.checkDate = ''
          this.checkDates = []
          this.classType = -1
          this.videoLink = ""
        }
      }
    }
  },
  created() {
    userExtInfo().then(res=>{
      this.TLState = res.data.Body.TLState;
    })
  }
}
</script>
<style>
.class-video-link.theme--light.v-input:not(.v-input--is-disabled) input{
    color:#3E67FB !important;
    text-decoration: underline;
}
</style>
